var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: ".9vw",
    height: ".9vw",
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.13049 2.23422L4.93437 5.33325L7.00039 11.7658M7.00039 11.7658L9.12078 5.27888L7.97903 2.23422M7.00039 11.7658L1.40039 5.38762M7.00039 11.7658L12.6004 5.38762M1.40039 5.38762L3.79262 2.23422H10.2625L12.6004 5.38762M1.40039 5.38762H12.6004",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardDiamond);
export default __webpack_public_path__ + "static/media/card_diamond.a7ebd2e91daa3049d9361d21266233f9.svg";
export { ForwardRef as ReactComponent };